/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IStateSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.StateWorkflowBlock;
        isReadonly: boolean;
        openOutputOrderModal: () => void;
    }

    export class StateSettingsModalController extends BaseModalController {
        scope: IStateSettingsModalControllerScope;
        private processConfigId: string;

        constructor(
            $scope: IStateSettingsModalControllerScope,
            workflowBlock: models.StateWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            workflowService: services.WorkflowService,
            close: any)
        {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            
            this.processConfigId = processConfigId;


            this.scope.openOutputOrderModal = () => {
                workflowService.showOutputOrderModal(this.scope.workflowBlock, this.scope.isReadonly);
            }
        }
    }
}

warsApp.registerController('StateSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'workflowService', 'close']);